import { render, staticRenderFns } from "./Prueba.vue?vue&type=template&id=5a9ebba7&"
import script from "./Prueba.vue?vue&type=script&lang=js&"
export * from "./Prueba.vue?vue&type=script&lang=js&"
import style0 from "./Prueba.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Prueba.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports